<footer class="site-footer pb-3 pt-4 pt-lg-5  mt-0" [ngClass]="themeClass('footer-section1')">
   <div class="footer-top-img" *ngIf="chTheme12">
              <img [src]="commonImagePath+ 'footer_gradient.webp'" alt="footer-top-img">
            </div>
   <div class="container footer-margin" >
      <app-top-footer (footerLoaded)="onTopFooterLoaded()" [showContactDetails]="showContactDetails">
      </app-top-footer>
      <app-sub-footer *ngIf="isTopFooterLoaded" [showSocialIconsCopyright]="showSocialIconsCopyright">
      </app-sub-footer>
   </div>
</footer>